import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'vant/lib/index.css';
import './style/default.css'
import './style/public.scss'
import './style/var.scss'
import './style/senke.scss'

import MyLoading from "@/util/MyLoading";


import vant from 'vant';
import { Image as VanImage } from 'vant';
import { Loading } from 'vant';
createApp(App).use(Loading).use(MyLoading).use(store).use(router).use(vant).use(VanImage).mount('#app')
